module.exports = ".privacy-wrapper {\n  min-height: 100vh;\n  margin-top: 200px; }\n"